import { initializeApp, getApps } from "firebase/app";
import {
  deleteToken,
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging";
import { handleFcmNotificationMessage, isChatFcmPayload, parseWebFcmPayload } from "./fcmNotificationHandler";
import { registerPwaServiceWorker } from "../utils/pwaInstall";

const firebaseConfig = {
  apiKey: "AIzaSyBwBxytxMUH65hUzVIyDhshQrgoFYlOJUw",
  authDomain: "mfg-invest.firebaseapp.com",
  projectId: "mfg-invest",
  storageBucket: "mfg-invest.firebasestorage.app",
  messagingSenderId: "968533227563",
  appId: "1:968533227563:web:a0c4b98a11e9c2a3dd526e",
};

const FCM_TOKEN_STORAGE_KEY = "mfg_web_fcm_token";

const getFirebaseApp = () => {
  if (getApps().length > 0) return getApps()[0];
  return initializeApp(firebaseConfig);
};

const ensureMessaging = async () => {
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(getFirebaseApp());
};

export const getWebFcmToken = async () => {
  try {
    const messaging = await ensureMessaging();
    if (!messaging) return null;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const serviceWorkerRegistration = await registerPwaServiceWorker();
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
    const token = await getToken(messaging, {
      serviceWorkerRegistration: serviceWorkerRegistration || undefined,
      ...(vapidKey ? { vapidKey } : {}),
    });

    if (token) {
      localStorage.setItem(FCM_TOKEN_STORAGE_KEY, token);
    } else {
      localStorage.removeItem(FCM_TOKEN_STORAGE_KEY);
    }

    return token || null;
  } catch (_) {
    return null;
  }
};

export const deleteWebFcmToken = async () => {
  try {
    const messaging = await ensureMessaging();
    if (!messaging) return;
    await deleteToken(messaging);
  } catch (_) {
    // Ignore local token deletion failures during logout.
  } finally {
    localStorage.removeItem(FCM_TOKEN_STORAGE_KEY);
  }
};

let foregroundUnsubscribe = null;

/**
 * Foreground FCM: mirror Flutter FirebaseMessaging.onMessage → handlerMessage(..., true).
 */
export async function attachForegroundFcm(navigate, isLoggedIn) {
  const messaging = await ensureMessaging();
  if (!messaging) return () => {};

  if (typeof foregroundUnsubscribe === "function") {
    foregroundUnsubscribe();
    foregroundUnsubscribe = null;
  }

  foregroundUnsubscribe = onMessage(messaging, (payload) => {
    if (typeof isLoggedIn === "function" && !isLoggedIn()) return;
    (async () => {
      await handleFcmNotificationMessage(navigate, payload, true);
      const note = payload?.notification || {};
      const parsed = parseWebFcmPayload(payload);
      const title =
        note.title != null && String(note.title).trim() !== ""
          ? String(note.title)
          : parsed?.title || "Notification";
      const body =
        note.body != null && String(note.body).trim() !== ""
          ? String(note.body)
          : parsed?.body || "";
      if (!title && !body) return;
      if (isChatFcmPayload(payload)) return;
      try {
        window.dispatchEvent(
          new CustomEvent("mfg:fcm-foreground-toast", {
            detail: { title: String(title), body: String(body) },
          })
        );
      } catch (_) {}
    })();
  });

  return () => {
    if (typeof foregroundUnsubscribe === "function") {
      foregroundUnsubscribe();
      foregroundUnsubscribe = null;
    }
  };
}

